import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "loading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useTheme } from '../../../utils/themeContext';
import { getButtonThemeClass } from './helpers';
import * as styles from './Button.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Button = function Button(_ref) {
  var children = _ref.children,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var buttonClassNames = clsx(styles['button'], getButtonThemeClass(theme), loading && styles['button--loading']);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: buttonClassNames
  }, props), {}, {
    children: [loading && /*#__PURE__*/_jsx("span", {
      className: styles['spinner'],
      "data-testid": "button-spinner",
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "current_color",
        size: 20
      })
    }), /*#__PURE__*/_jsx("span", {
      className: styles['content'],
      children: children
    })]
  }));
};